import React, { FC, useState } from 'react';
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js';
import { useTranslations } from 'next-intl';
import { Button } from '../../design-system';

interface Props {
  onSubmit: () => void;
  isLoading?: boolean;
  error?: string;
  onChange: () => void;
}

export const CardForm: FC<Props> = ({
  onSubmit,
  isLoading,
  error,
  onChange,
}) => {
  const t = useTranslations('common');
  const [num, setNum] = useState(false);
  const [exp, setExp] = useState(false);
  const [cvc, setCvc] = useState(false);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <h2 className={'tw-text-2xl tw-font-bold'}>{t('cardForm.title')}</h2>
      <div className="tw-grid tw-grid-cols-2 tw-gap-1 tw-gap-x-6">
        <label className="tw-block tw-col-span-2">
          <span className="tw-text-base tw-block tw-text-gray-700 tw-mb-1">
            {t('cardForm.cardNumber')}
          </span>
          <CardNumberElement
            options={{ disabled: isLoading }}
            className="tw-form-input tw-block tw-w-full tw-rounded-md tw-shadow-sm focus:tw-border-gray-300 focus:tw-ring focus:tw-ring-gray-200 focus:tw-ring-opacity-50 disabled:tw-bg-gray-100 disabled:tw-cursor-not-allowed disabled:tw-text-gray-500 disabled:tw-border-gray-200 disabled:tw-shadow-none tw-border-gray-300 tw-bg-white"
            onChange={(event) => {
              onChange();
              setNum(event.complete);
            }}
          />
        </label>
        <label className="tw-block">
          <span className="tw-text-base tw-block tw-text-gray-700 tw-mb-1">
            {t('cardForm.expiration')}
          </span>
          <CardExpiryElement
            options={{ disabled: isLoading }}
            className="tw-form-input tw-block tw-w-full tw-rounded-md tw-shadow-sm tw-border-gray-300 tw-bg-white"
            onChange={(event) => {
              onChange();
              setExp(event.complete);
            }}
          />
        </label>
        <label className="tw-block">
          <span className="tw-text-base tw-block tw-text-gray-700 tw-mb-1">
            CVC
          </span>
          <CardCvcElement
            options={{ disabled: isLoading }}
            className="tw-form-input tw-block tw-w-full tw-rounded-md tw-shadow-sm tw-border-gray-300 tw-bg-white"
            onChange={(event) => {
              onChange();
              setCvc(event.complete);
            }}
          />
        </label>
      </div>
      <div>
        {!!error && <div className="tw-text-error">{error}</div>}

        <Button
          className={'tw-mt-3'}
          type="submit"
          disabled={!(num && exp && cvc) || isLoading}
          loading={isLoading}
        >
          {t('cardForm.confirm')}
        </Button>
      </div>
    </form>
  );
};
